import React, { useEffect, useState } from "react";
import { Col, Form, Input, Radio, Row, Icon, Collapse, Modal, Tag } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Text from "antd/lib/typography/Text";
const { Item } = Form;
const { Panel } = Collapse;

const WhatsupTemplate = (props) => {
  const [lengends, setLengents] = useState("");
  const [name, setName] = useState(props.data?.name || "");
  const [text, setText] = useState(props.data?.text || "");

  useEffect(() => {
    if (props.data) {
      if (props.data.legends) {
        try {
          const parsed = JSON.parse(props.data.legends);
          setLengents(parsed.join("\n"));
        } catch (e) {
          setLengents(props.data.legends);
        }
      } else {
        setLengents("");
      }
      setName(props.data?.name);
      setText(props.data?.text);
    }
  }, [props.data, props.edit]);

  const handleSubmit = () => {
    // Convert back to JSON array format
    const legendsArray = (typeof lengends === 'string' ? lengends : "")
      .split("\n")
      .map(l => l.trim())
      .filter(l => l !== "");

    props.data["name"] = name;
    props.data["text"] = text;
    props.data["legends"] = JSON.stringify(legendsArray);

    props.updateTemplate(props.data, props.index);
  };

  return (
    <div>
      <Modal
        title={props.edit ? "Edit Template" : "View Template"}
        onOk={() => (!props.edit ? props.setEdit(true) : handleSubmit())}
        onCancel={() => {
          props.close();
        }}
        visible={props.visible}
        okText={props.edit ? "Save" : "Modify"}
        okButtonProps={(!props.edit && !props.modifyAccess) ? { style: { display: "none" } } : undefined}
        wrapClassName="Template-modal"
      >
        <Form>
          <Row justify="center" type="flex">
            <Text strong style={{ marginBottom: "15px" }}>
              {props.data ? props.data.name + " - " + props.data.submodule : ""}
            </Text>
          </Row>
          <Row justify="center" type="flex">
            <Col span={24}>
              <Item label="Template Name" colon={false}>
                <Input
                  placeholder="Template Name"
                  disabled={!props.edit}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Item>
            </Col>
          </Row>
          <Row justify="center" type="flex">
            <Col span={24}>
              <Item label="Whatsup Text" colon={false}>
                <TextArea
                  disabled={!props.edit}
                  placeholder="Whatsup Text"
                  autoSize={{ minRows: 3 }}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                ></TextArea>
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Item label="Legends (One per line)" colon={false}>
                <TextArea
                  disabled={!props.edit}
                  placeholder="Legends (e.g., Customer Name: ${cname})"
                  autoSize={{ minRows: 3 }}
                  value={lengends}
                  onChange={(e) => setLengents(e.target.value)}
                />
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: "right", marginTop: "10px" }}>
              <Item label="Whatsapp Status" colon={false}>
                {(props.data?.status === "approved" || props.data?.status === "APPROVED") && (
                  <Tag color="#87d068">{props.data?.status}</Tag>
                )}
                {props.data?.status === "pending" || props.data?.status === "PENDING" && (
                  <Tag color="#F7CD2E">{props.data?.status}</Tag>
                )}
                {props.data?.status === "rejected" || props.data?.status === "REJECTED" && (
                  <Tag color="#cd201f">{props.data?.status}</Tag>
                )}
                {(!props.data?.status || props.data?.status === "NO") && (
                  <Tag color="default">No Status</Tag>
                )}
              </Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default WhatsupTemplate;
